import { IconProps, iconA11yProps } from '../types';

export const MinMax = ({ classNames, label }: IconProps) => (
	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="size-6 stroke-white" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...iconA11yProps(label)}>
		<path d="M21 17C21 16.7348 20.8946 16.4804 20.7071 16.2929C20.5196 16.1054 20.2652 16 20 16H17C16.7348 16 16.4804 16.1054 16.2929 16.2929C16.1054 16.4804 16 16.7348 16 17V20C16 20.2652 16.1054 20.5196 16.2929 20.7071C16.4804 20.8946 16.7348 21 17 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V17Z" />
		<path d="M20 12V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H12" />
		<mask id="mask0_1767_3828" maskUnits="userSpaceOnUse" x="6" y="6" width="12" height="12">
			<path d="M6 6H18V14H17C15.3431 14 14 15.3431 14 17V18H6V6Z" fill="#D9D9D9" />
		</mask>
		<g mask="url(#mask0_1767_3828)">
			<g id="arrow" className={`${classNames} origin-center [transform-box:fill-box]`}>
				<path d="M9 13H13V9" />
				<path d="M13 13L8 8" />
			</g>
		</g>
	</svg>
);
